export enum HomeMatchMode {
    Basic = 1,
    Lite = 2,
    Tinder = 3
}

export const homeMatchModeLabels: Record<HomeMatchMode, string> = {
    [HomeMatchMode.Basic]: "Basic",
    [HomeMatchMode.Lite]: "Lite",
    [HomeMatchMode.Tinder]: "Tinder"
};
export enum HomeMatchMode {
    Basic = 1,
    Lite = 2,
    Tinder = 3
}

export const homeMatchModeLabels: Record<HomeMatchMode, string> = {
    [HomeMatchMode.Basic]: "Basic",
    [HomeMatchMode.Lite]: "Lite",
    [HomeMatchMode.Tinder]: "Tinder"
};
